<script setup>
import {ref, watch} from 'vue';
import BaseInputFloatingLabelNumber from "@/components/forms/BaseInputFloatingLabelNumber.vue";

const props = defineProps({
  modelValue: [Number, String],
  label: String
});

const emits = defineEmits(['update:modelValue']);

const localValue = ref(props.modelValue);

const updateValue = () => {
  if (localValue.value <= 1) localValue.value = 1.0001;
  emits('update:modelValue', localValue.value);
};

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue);
});


</script>

<template>
  <BaseInputFloatingLabelNumber
      :config="{ label: label, hasClearButton: false }"
      v-model="localValue" @change="updateValue"/>
</template>

<style scoped>
/* Add your styles here */
</style>
